var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-date-picker',{style:(_vm.current.style),attrs:{"size":_vm.current.size,"type":"date","placeholder":"选择日期"},model:{value:(_vm.current.value),callback:function ($$v) {_vm.$set(_vm.current, "value", $$v)},expression:"current.value"}})}
var staticRenderFns = []

export { render, staticRenderFns }